import React, { useContext } from 'react';
import { systemCode, xs_languageCode, xs_sessionToken } from '../..';
import { UserContext } from '../../data/betslip/UserConf';

function getFrameType(type, url) {
    if (type === 'ROULETTE_VIDEO') {
        return 'video';
    } else if (url.indexOf(".png") >= 0  ||
               url.indexOf(".jpg") >= 0  ||
               url.indexOf(".jpeg")>= 0  ||
               url.indexOf(".gif") >= 0  ||
               url.indexOf(".svg") >= 0) {
        return 'image';
    } else {
        return 'iframe';
    }
}

export default function FrameGame(props) {
	const frameGame = props.frameGame;
	const userContext = useContext(UserContext);
	const user = userContext.getUser();
	
	// generating the game  url
	let gameUrl = frameGame.lurl;
	gameUrl = gameUrl.replace(/{{LANGUAGE}}/g, xs_languageCode.toLowerCase());
	gameUrl = gameUrl.replace(/{{TOKEN}}/g, xs_sessionToken);
	gameUrl = gameUrl.replace(/{{SYSTEM_CODE}}/g, systemCode);
	
	let unloggedUrl = frameGame.uurl;
	unloggedUrl = unloggedUrl.replace(/{{LANGUAGE}}/g, xs_languageCode.toLowerCase());
	unloggedUrl = unloggedUrl.replace(/{{TOKEN}}/g, xs_sessionToken);
	unloggedUrl = unloggedUrl.replace(/{{SYSTEM_CODE}}/g, systemCode);
	
	const type = getFrameType(frameGame.typ, unloggedUrl);
	const width = frameGame.wth === 0 ? '100%' : frameGame.wth;
	const height = frameGame.hgt;

	const frameSectionCss = frameGame.typ === '10&LOTTO' ? '10_lotto betslipSideGame' : `${frameGame.typ} betslipSideGame`;
	const sectionClass =  `${frameSectionCss} no-bg widget-ultimi bg-bianco bordo-tondo margine-giu widget-betslip`;
    
	function openCgLoginPopup() {
		if (typeof window.cg_showLoginModal === 'function') {
			window.cg_showLoginModal();
		}
	}

	return (
        <div className={sectionClass}>
            {user.logged ?
                <div className="frame-game" id={frameGame.elid} >
                    <iframe title="Roulette game" src={gameUrl} width={width} height={height} frameBorder="0"></iframe>
                </div>
                :
                <div className="frame-game pointer" id={frameGame.elid} onClick={openCgLoginPopup}>
                    {type === 'video' &&
                        <video height="690px" width="290px" autoPlay muted loop playsInline>
                            <source src={`${process.env.PUBLIC_URL}/assets/img/cart-game.webm`} type="video/webm" />
                            <source src={`${process.env.PUBLIC_URL}/assets/img/cart-game.mp4`} type="video/mp4" />
                        </video>
                    }
                    {type === 'image' &&
                        <img alt="Route game animation" src={unloggedUrl} />						
                    }
                    {type === 'iframe' &&
                        <iframe title="Roulette game animation" src={unloggedUrl} width={width} height={height} frameBorder="0"></iframe>
                    }
                </div>	   
            }
        </div>
    );
}
